import { render, staticRenderFns } from "./NVR.vue?vue&type=template&id=e04702b0&scoped=true"
import script from "./NVR.vue?vue&type=script&lang=js"
export * from "./NVR.vue?vue&type=script&lang=js"
import style0 from "./NVR.vue?vue&type=style&index=0&id=e04702b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04702b0",
  null
  
)

export default component.exports